import { securityControls } from "@/content/trust";
import { Card } from "@/components/ui/Card";
import { GlobalCTA } from "@/components/ui/CTA";
import { List } from "@/components/ui/List";
import { PageHero } from "@/components/ui/PageHero";
import { Section } from "@/components/ui/Section";

export default function SecurityPage() {
  return (
    <>
      <PageHero
        eyebrow="Security"
        title="Controlled access and auditable execution"
        description="Agentic Plus separates workspaces, permissions, approvals, and evidence. The platform treats ambiguous external states as unknown and preserves the record needed to verify or compensate an action."
      />

      <Section title="Security and governance model" tone="surface">
        <div className="grid gap-6 md:grid-cols-2">
          {securityControls.map((control) => (
            <Card key={control.title} title={control.title} description={control.description}>
              <List items={control.points} className="mt-4" />
            </Card>
          ))}
        </div>
      </Section>

      <Section title="Review principles" tone="paper">
        <div className="grid gap-6 md:grid-cols-3">
          {[
            {
              title: "Least privilege",
              description: "A user receives only the access needed for assigned workspace work.",
            },
            {
              title: "Explicit authorization",
              description:
                "High-cost and external actions are confirmed against the specific plan or version.",
            },
            {
              title: "Traceable outcomes",
              description:
                "Records make it possible to answer what changed, who approved it, and what happened.",
            },
          ].map((item) => (
            <article key={item.title} className="surface-card p-6">
              <h3 className="text-xl font-bold">{item.title}</h3>
              <p className="mt-3 text-ink-soft">{item.description}</p>
            </article>
          ))}
        </div>
      </Section>

      <GlobalCTA />
    </>
  );
}
